import { render } from "./ForgotPassword.vue?vue&type=template&id=703e1a01&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-703e1a01"

export default script